export const getTranslatedOptions = (t, options, key = 'text', formatOption) =>
  options.map((option) => {
    const translatedOption = t(option[key])
    return { ...option, [key]: formatOption?.(option, translatedOption) || translatedOption }
  })
